//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ConfirmLoadEmailTemplateModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleConfirmClick() {
      this.$emit("submit");
    },
    handleHide($event) {
      this.$emit("hide", $event);
      this.$emit("cancel");
    }
  }
});